import {match} from 'ts-pattern';

import {type PkwEnvkvWorkflowStatus} from '@dms/api/vehicle';

export const PKW_ENVKV_STATUS_POLLING_INTERVAL_MS = 5_000;

/**
 * Only CALCULATING and GENERATING are transient backend states; every other
 * workflow status stays until the user acts, so it is not worth polling.
 */
export const getPollingInterval = (workflowStatus: PkwEnvkvWorkflowStatus | undefined): number =>
  match(workflowStatus)
    .with('CALCULATING', 'GENERATING', () => PKW_ENVKV_STATUS_POLLING_INTERVAL_MS)
    .otherwise(() => 0);
